import { HttpService } from "services";
import { TitleCompanies, User } from "types/entities";

import {
  UpdateTitleCompanyFunction,
  UpdateTitleCompanyFunctionParams,
} from "types/functions/updateTitleCompany";
import { AuthorizationLevel } from "types/http";

/**
 * Retrieve detailed information about listing
 *
 * @throws {HttpServiceException}
 */
export const updateTitleCompany: UpdateTitleCompanyFunction = async (
  params: UpdateTitleCompanyFunctionParams
) => {
  try {
    const { companyId, demographics } = params;

    const payload = {
      title_company: demographics.title_company,
      company_address: demographics.company_address,
      phone_no: demographics.phone_no,
      email: demographics.email,
      territory: demographics.territory,
    };

    const url = `/title-company/${companyId}`;
    const res: TitleCompanies = await HttpService.fetch(
      url,
      {
        requestConfig: {
          method: "PUT", // Adjusted to match the "create-demographics" endpoint semantics
          data: payload,
        },
      },
      AuthorizationLevel.AUTHORIZED
    );

    return res;
  } catch (error) {
    throw error;
  }
};
